import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";

import ModifyRow from "./ModifyRow";
import ScanRow from "./ScanRow";
import RequestRow from "./RequestRow";
import ErrorRow from "./ErrorRow";

const LiveSession = ({ event }) => {
  if(event.error) {
    return(<ErrorRow event={event}/>)
  }

  if(event.placeholder) {
    return(<RequestRow event={event}/>)
  }

  if(event.actionType === 'scan') {
    return(<ScanRow event={event}/>)
  }

  if(event.actionType === 'set') {
    return(<ModifyRow event={event} type='Set Inventory' />)
  }

  if(event.actionType === 'add') {
    return(<ModifyRow event={event} type='Add Inventory' />)
  }

  if(event.actionType === 'subtract') {
    return(<ModifyRow event={event} type='Subtract Inventory' />)
  }
}

export default LiveSession;